import { FunctionComponent } from 'react'
import { useNavigate, useOutletContext } from 'react-router-dom'
import { PureSiteConnectToPubstack } from '~/modules/adm/inventory/sites/PureSiteConnectToPubstack'
import { AdmSitePageContext } from '~/modules/pbs/sites/site/useSitePageContext'

export const SiteConnectToPubstack: FunctionComponent = () => {
  const { site, isLoading } = useOutletContext<AdmSitePageContext>()
  const navigate = useNavigate()
  return <PureSiteConnectToPubstack site={site} isLoading={isLoading} onUseAnalyticsScriptsClick={() => navigate('/settings/sites')} />
}
